import { z } from 'zod';
import { ACCOUNT_TYPES, type AccountType } from '../types';
import { centsSchema, isoDateSchema } from './common';

export const accountCreateSchema = z.object({
  name: z.string().trim().min(1, 'Nom obligatoire').max(80),
  type: z.enum(ACCOUNT_TYPES),
  /** Solde connu à `openedOn` : tout le reste se déduit des transactions. */
  initialBalanceCents: centsSchema.default(0),
  openedOn: isoDateSchema,
  icon: z.string().trim().max(8).optional(),
  color: z.string().trim().max(20).nullable().optional(),
  sortOrder: z.number().int().min(0).optional(),
});

export const accountUpdateSchema = accountCreateSchema.partial();

/**
 * Recalage : on donne le solde que la banque affiche, le serveur écrit l'écart
 * sous forme d'ajustement. C'est le filet quand une dépense a été oubliée.
 */
export const accountReconcileSchema = z.object({
  balanceCents: centsSchema,
  occurredOn: isoDateSchema.optional(),
  note: z.string().trim().max(200).nullable().optional(),
});

export type AccountReconcileInput = z.infer<typeof accountReconcileSchema>;

export interface AccountReconcileResponse {
  account: AccountResponse;
  /** Écart constaté, nul si le solde était déjà juste. */
  adjustmentCents: number;
}

export type AccountCreateInput = z.infer<typeof accountCreateSchema>;
export type AccountUpdateInput = z.infer<typeof accountUpdateSchema>;

export interface AccountResponse {
  id: string;
  name: string;
  type: AccountType;
  initialBalanceCents: number;
  openedOn: string;
  icon: string;
  color: string | null;
  sortOrder: number;
  archivedAt: string | null;
  /** Solde à date : solde initial + somme des mouvements. */
  balanceCents: number;
}
